export default __webpack_public_path__ + "static/media/img_canal_no_image.611da730.svg";